/* Sofatica cart-drawer store-credit customizer — ports the TPH drawer treatment to the
   Dawn drawer. Scoped to `.cart-drawer` so the cart-page widget is untouched. Idempotent
   and re-applied on the app's re-renders via a MutationObserver. Paired with
   credit-redeem-custom.css. */
(function () {
  "use strict";
  var SCOPE = ".cart-drawer";

  function setupCreditAccordion() {
    var cards = document.querySelectorAll(SCOPE + " .credit-redeem__card:not([data-cd-accordion])");
    Array.prototype.forEach.call(cards, function (card) {
      var header = card.querySelector(".credit-redeem__header");
      if (!header) return;
      card.setAttribute("data-cd-accordion", "1");
      card.classList.add("is-collapsed");

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cd-credit-toggle";
      btn.setAttribute("aria-label", "Toggle store credit");
      btn.setAttribute("tabindex", "-1");
      btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 6l4.5 4.5L12.5 6"></path></svg>';
      header.appendChild(btn);

      header.classList.add("cd-credit-header--toggle");
      header.setAttribute("role", "button");
      header.setAttribute("tabindex", "0");
      header.setAttribute("aria-expanded", "false");
      function toggleCard() {
        var collapsed = card.classList.toggle("is-collapsed");
        header.setAttribute("aria-expanded", collapsed ? "false" : "true");
      }
      header.addEventListener("click", function (e) {
        if (e.target.closest("a, input")) return;
        e.preventDefault();
        toggleCard();
      });
      header.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          toggleCard();
        }
      });
    });
  }

  function setupCreditApplied() {
    // process the drawer widget AND the cart-page app-block widget (structural fixes apply to both)
    var rows = document.querySelectorAll(".cart-drawer .credit-redeem__row--success, .shopify-app-block .credit-redeem__row--success");
    Array.prototype.forEach.call(rows, function (row) {
      var container = row.parentElement;
      if (!container) return;
      container.classList.add("cd-credit-applied");

      // strip the leading check glyph from "✓ Store credit applied"
      var span = row.querySelector("span");
      if (span && span.textContent.indexOf("✓") !== -1) {
        span.textContent = span.textContent.replace(/^[\s✓]+/, "").trim();
      }

      // remaining balance inline next to the applied amount: "$50 / $0"
      var appliedStrong = row.querySelector("[data-credit-redeem-applied]");
      if (appliedStrong && !appliedStrong.querySelector(".cd-credit-balance")) {
        var remEl = container.querySelector("[data-credit-redeem-remaining]");
        var remText = remEl ? (remEl.textContent || "").trim() : "";
        if (!remText || remText === "—") remText = "$0";
        var bal = document.createElement("span");
        bal.className = "cd-credit-balance";
        bal.textContent = " / " + remText;
        appliedStrong.appendChild(bal);
      }

      // replace the "Remove credit" button with a trash icon on the hint line
      var hint = container.querySelector(".credit-redeem__hint");
      if (hint && !container.querySelector(".cd-credit-remove")) {
        var removeBtn = null;
        Array.prototype.forEach.call(container.querySelectorAll("button"), function (b) {
          if (/remove credit/i.test(b.textContent || "")) removeBtn = b;
        });
        var trash = document.createElement("button");
        trash.type = "button";
        trash.className = "cd-credit-remove";
        trash.setAttribute("aria-label", "Remove store credit");
        trash.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 4h11"></path><path d="M6 4V2.9c0-.5.4-.9.9-.9h2.2c.5 0 .9.4.9.9V4"></path><path d="M11.9 4l-.5 8.4c-.03.55-.5 1-1 1H5.6c-.5 0-.97-.45-1-1L4.1 4"></path><path d="M6.7 6.5v4.4M9.3 6.5v4.4"></path></svg>';
        trash.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (removeBtn) removeBtn.click();
        });
        var hintRow = document.createElement("div");
        hintRow.className = "cd-credit-hint-row";
        hint.parentNode.insertBefore(hintRow, hint);
        hintRow.appendChild(hint);
        hintRow.appendChild(trash);
      }
    });
  }

  // Empty cart page: the cart-items section sits in column 1 of the theme's 2-col grid, so the
  // empty-state message ends up left-of-center. Stylesheet grid-column can't override the theme's
  // grid-area placement — only an inline style does — so span the section full-width here.
  function centerEmptyCart() {
    if (!document.body.classList.contains("template-cart")) return;
    var w = document.querySelector(".cart__warnings");
    if (!w) return;
    var sec = w.closest(".shopify-section");
    if (sec && sec.parentElement && sec.parentElement.matches && sec.parentElement.matches("main.content-for-layout")) {
      sec.style.setProperty("grid-column", "1 / -1", "important");
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      setupCreditAccordion();
      setupCreditApplied();
      centerEmptyCart();
    });
  }

  function init() {
    setupCreditAccordion();
    setupCreditApplied();
    centerEmptyCart();
    // the app re-injects the widget when Dawn re-renders the drawer — re-apply then.
    var target = document.querySelector("cart-drawer") || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    // cart page: the store-credit app block lives outside the drawer — watch the page too.
    if (document.body.classList.contains("template-cart")) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
